// Painel lateral com as propriedades do componente selecionado.
import React, { useCallback } from "react";
import * as AlfredoStyles from "../../../../styles/components/configuration/modals/ItemModal";
import { PDVComponent } from "./tipos";

export const PropriedadesDoComponente: React.FC<{
  component: PDVComponent;
  onUpdate: (componentId: string, updates: any) => void;
}> = ({ component, onUpdate }) => {
  const handlePropChange = useCallback(
    (propPath: string, value: any) => {
      const pathParts = propPath.split(".");
      if (pathParts[0] === "componentProps") {
        onUpdate(component.componentId, {
          componentProps: {
            ...component.componentProps,
            [pathParts[1]]: value,
          },
        });
      } else {
        onUpdate(component.componentId, {
          [propPath]: value,
        });
      }
    },
    [component, onUpdate]
  );

  return (
    <AlfredoStyles.PropertiesForm>
      <AlfredoStyles.FormSection>
        <AlfredoStyles.SectionTitle>
          Configurações Básicas
        </AlfredoStyles.SectionTitle>

        <AlfredoStyles.InputGroup>
          <label>Nome do Componente</label>
          <AlfredoStyles.Input
            type="text"
            value={component.componentName}
            onChange={(e) => handlePropChange("componentName", e.target.value)}
          />
        </AlfredoStyles.InputGroup>

        <AlfredoStyles.InputGroup>
          <label>Status</label>
          <AlfredoStyles.Select
            value={component.componentStatus}
            onChange={(e) =>
              handlePropChange("componentStatus", e.target.value)
            }
          >
            <option value="visible">Visível</option>
            <option value="hidden">Oculto</option>
          </AlfredoStyles.Select>
        </AlfredoStyles.InputGroup>
      </AlfredoStyles.FormSection>

      <AlfredoStyles.FormSection>
        <AlfredoStyles.SectionTitle>
          Posição e Tamanho
        </AlfredoStyles.SectionTitle>

        <AlfredoStyles.Grid2x2>
          <AlfredoStyles.InputGroup>
            <label>Posição X</label>
            <AlfredoStyles.Input
              type="text"
              value={component.componentProps.componentPosition?.x || "0%"}
              onChange={(e) =>
                handlePropChange(
                  "componentProps.componentPosition.x",
                  e.target.value
                )
              }
            />
          </AlfredoStyles.InputGroup>

          <AlfredoStyles.InputGroup>
            <label>Posição Y</label>
            <AlfredoStyles.Input
              type="text"
              value={component.componentProps.componentPosition?.y || "0%"}
              onChange={(e) =>
                handlePropChange(
                  "componentProps.componentPosition.y",
                  e.target.value
                )
              }
            />
          </AlfredoStyles.InputGroup>

          <AlfredoStyles.InputGroup>
            <label>Largura</label>
            <AlfredoStyles.Input
              type="text"
              value={component.componentProps.componentWidth || "100px"}
              onChange={(e) =>
                handlePropChange(
                  "componentProps.componentWidth",
                  e.target.value
                )
              }
            />
          </AlfredoStyles.InputGroup>

          <AlfredoStyles.InputGroup>
            <label>Altura</label>
            <AlfredoStyles.Input
              type="text"
              value={component.componentProps.componentHeight || "40px"}
              onChange={(e) =>
                handlePropChange(
                  "componentProps.componentHeight",
                  e.target.value
                )
              }
            />
          </AlfredoStyles.InputGroup>
        </AlfredoStyles.Grid2x2>
      </AlfredoStyles.FormSection>

      <AlfredoStyles.FormSection>
        <AlfredoStyles.SectionTitle>Estilo Visual</AlfredoStyles.SectionTitle>

        <AlfredoStyles.ColorGrid>
          <AlfredoStyles.InputGroup>
            <label>Cor de Fundo</label>
            <AlfredoStyles.ColorInput
              color={
                component.componentProps.componentBackgroundColor || "#1D50FF"
              }
            >
              <input
                type="color"
                value={
                  component.componentProps.componentBackgroundColor || "#1D50FF"
                }
                onChange={(e) =>
                  handlePropChange(
                    "componentProps.componentBackgroundColor",
                    e.target.value
                  )
                }
              />
              <label>Fundo</label>
            </AlfredoStyles.ColorInput>
          </AlfredoStyles.InputGroup>

          <AlfredoStyles.InputGroup>
            <label>Cor do Texto</label>
            <AlfredoStyles.ColorInput
              color={component.componentProps.componentColor || "#FFFFFF"}
            >
              <input
                type="color"
                value={component.componentProps.componentColor || "#FFFFFF"}
                onChange={(e) =>
                  handlePropChange(
                    "componentProps.componentColor",
                    e.target.value
                  )
                }
              />
              <label>Texto</label>
            </AlfredoStyles.ColorInput>
          </AlfredoStyles.InputGroup>
        </AlfredoStyles.ColorGrid>
      </AlfredoStyles.FormSection>
    </AlfredoStyles.PropertiesForm>
  );
};
